import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Timetable } from './Timetable';

export interface TimetableGroupRow {
  id: number;
  timetable_id: number;
  name: string;
  color_code?: string | null;
  created_at: string;
  updated_at: string;
}

export const TimetableGroup: Entity<TimetableGroupRow> = {
  id: 'TimetableGroup',
  title: 'Timetable Group',
  service: 'main',
  rowLabel: (row: TimetableGroupRow) => row.name,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.timetable_group',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'ID',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    timetable_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Timetable',
      refEntity: Timetable,
      mandatory: true,
      listColumn: true,
    },
    name: {
      seq: 15,
      type: FieldType.Text,
      label: 'Name',
      mandatory: true,
      listColumn: true,
    },
    color_code: {
      seq: 20,
      type: FieldType.Colour,
      label: 'Colour',
      mandatory: false,
      listColumn: true,
    },
    created_at: {
      seq: 40,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
    },
    updated_at: {
      seq: 45,
      type: FieldType.Datetime,
      label: 'Updated At',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
